module.exports = __webpack_public_path__ + "img/logo-sem-escrita.5afa2f49.svg";